// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MVx5","expireSoon":"styles_expireSoon__G190X"};